export default "__VITE_ASSET__C2jG4yOR__"